function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavOffersPin2 = function SvgNavOffersPin2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24 14.5c-2.8 0-5.1 2.3-5.1 5.1 0 1.4.2 2.8.7 4.3.4 1.3.9 2.5 1.7 3.8 1.3 2.2 2.4 3.7 2.4 3.8.1.1.2.2.3.2s.2-.1.3-.2c.1-.1 1.3-1.6 2.4-3.8.7-1.3 1.3-2.6 1.7-3.8.5-1.6.7-3 .7-4.3 0-2.8-2.3-5.1-5.1-5.1zm0 7c-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2 2.2 1 2.2 2.2-1 2.2-2.2 2.2z",
    style: {
      fill: "#666"
    }
  }));
};
export default SvgNavOffersPin2;